import React from 'react'
import { GridCell, GridFilterCell } from '@progress/kendo-react-grid'
import { Select } from 'components/select'
import { localized } from 'decorators'
import { isNotNull } from 'utils/isNotNull'

const enumCell = ({ enum: enumType }) => {
  return localized(class EnumCell extends GridCell {
    render () {
      const value = this.props.dataItem[this.props.field]
      let displayedValue = ''
      if (isNotNull(value)) {
        displayedValue = this.props.localize(`enums.${enumType.name}_${value}`)
      }
      return (
        <td className='badge-cell'>{displayedValue}</td>
      )
    }
  })
}

const createEnumFilterCell = (props = {}) => {
  return class EnumFilterCell extends GridFilterCell {
    onValueChange = (value) => {
      this.props.onChange({
        value,
        operator: value !== null ? 'eq' : ''
      })
    }
    
    render () {
      const { value } = this.props
      return (
        <Select
          enum={props.enum}
          nullable
          menuPosition='fixed'
          value={value}
          onChange={this.onValueChange}
        />
      )
    }
  }
}
export {
  enumCell,
  createEnumFilterCell
}